import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-ocds-detail',
  templateUrl: './ocds-detail.component.html',
  styleUrls: ['./ocds-detail.component.scss']
})
export class OcdsDetailComponent implements OnInit, AfterViewInit {
  id: string = '';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id') || '';
    console.log('Loaded ID:', this.id);

    // Example: Call API here with this.id
    // this.loadTenderDetails(this.id);
  }

  ngAfterViewInit(): void {
    // DOM-related operations if needed
  }
}
